import React from "react";

export default function ApprovalPage() {
  // Creates and downloads a dummy text file when called
  const downloadDummyFile = () => {
    const content =
      "This is a dummy attachment file.\nGenerated for testing download functionality.";
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "dummy-attachment.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  /* ================= INLINE STYLES ================= */

  const wrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "32px 16px",
    background: "linear-gradient(135deg, #f8fafc)",
    boxSizing: "border-box",
    fontFamily:
      '"Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
  };

  const sectionStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    width: "100%",
    maxWidth: "520px",
  };

  const logoStyle = {
    maxWidth: "240px",
    width: "100%",
    height: "auto",
    marginBottom: "8px",
  };

  const cardStyle = {
    background: "#ffffff",
    padding: "28px 30px",
    borderRadius: "14px",
    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.08)",
    width: "100%",
  };

  const titleStyle = {
    marginBottom: "18px",
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#111827",
    textAlign: "center",
    borderBottom: "1px solid #e5e7eb",
    paddingBottom: "12px",
  };

  const textStyle = {
    margin: "6px 0",
    fontSize: "0.95rem",
    fontWeight: 500,
    color: "#374151",
    lineHeight: 1.4,
  };

  const downloadRowStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#f9fafb",
    border: "1px dashed #d1d5db",
    padding: "12px 14px",
    borderRadius: "10px",
    marginTop: "18px",
  };

  const buttonBase = {
    padding: "9px 18px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: 500,
    transition: "all 0.2s ease",
  };

  const downloadBtn = {
    ...buttonBase,
    backgroundColor: "#2563eb",
    color: "#ffffff",
  };

  const actionButtonsStyle = {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    marginTop: "22px",
  };

  const approveBtn = {
    ...buttonBase,
    flex: 1,
    backgroundColor: "#16a34a",
    color: "#ffffff",
  };

  const denyBtn = {
    ...buttonBase,
    flex: 1,
    backgroundColor: "#ef4444",
    color: "#ffffff",
  };

  /* ================= JSX ================= */

  return (
    <div style={wrapperStyle}>
      <div style={sectionStyle}>
        <img src="logo_black.png" alt="Approval" style={logoStyle} />

        <div style={cardStyle}>
          <h2 style={titleStyle}>Approval Request</h2>

          <h3 style={textStyle}>Act : ABCD</h3>
          <h3 style={textStyle}>Particular : ABCD</h3>
          <h3 style={textStyle}>Description : ABCD</h3>
          <h3 style={textStyle}>Title : ABCD</h3>
          <h3 style={textStyle}>Action Date : ABCD</h3>
          <h3 style={textStyle}>User Name : TEST</h3>
          <h3 style={textStyle}>User Email : test@gmail.com</h3>
          <h3 style={textStyle}>Department : HR</h3>
          <h3 style={textStyle}>Business Unit : Test1</h3>

          <div style={downloadRowStyle}>
            <h3 style={{ ...textStyle, margin: 0 }}>
              Download attachment
            </h3>
            <button style={downloadBtn} onClick={downloadDummyFile}>
              Download
            </button>
          </div>

          <div style={actionButtonsStyle}>
            <button style={approveBtn}>Confirm</button>
            <button style={denyBtn}>Decline</button>
          </div>
        </div>
      </div>
    </div>
  );
}
